import { BaseEntityDto, CompanyDto, UserDto } from '@fleet-beat/libs-core/src';

export interface TenantDto extends BaseEntityDto {
  id?: string;
  name?: string;
  company?: CompanyDto;
  owner?: UserDto;
  active?: boolean;
  payDate?: string;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
}
